import { Stack, Text } from "@chakra-ui/react";

import { ILocationSuggestion } from "utils/geo";

type SelectRowItemProps = {
  item: ILocationSuggestion;
  onSelect: (item: any) => void;
};

const SelectRowItem = ({ item, onSelect }: SelectRowItemProps) => (
  <Stack
    px="15px"
    py="10px"
    direction="row"
    align="center"
    justify="space-between"
    transition="all 333ms ease 0s"
    _hover={{ background: "#F1F1F1", cursor: "pointer" }}
    onMouseDown={(e) => e.preventDefault()}
    onClick={() => onSelect(item)}
  >
    <Stack direction="row" align="center">
      <Text>{item.label}</Text>
    </Stack>
  </Stack>
);

export default SelectRowItem;
